export default function fileField() {
  return {
    fileName: '',

    registerSelectedFile() {
      this.fileName = event.target.files.item(0).name;
    },
  };
}
